import React, { useEffect, useState } from "react";
import Table, { TableBody, TableHeader } from '@ingka/table';
import siteUrl from "../models/url-routes";
import { PPSMetaDataModel } from "../models/data-models";
import "../../app.scss"
import "@ingka/table/style.scss";
import { PPSTemplate } from "./pps-template";

export const PPSMetaDataTable: React.FC = () => {
  const [ metaData, setMetaData ] = useState<PPSMetaDataModel[]>([])
  useEffect(() => {
    fetch(`${siteUrl}/pps/ppsmetadata`, {
      method: "GET",
      headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        }
    })
    .then(async response => {
      setMetaData(await response.json())
    })
  },[])

  const listFormatter = (listString: string) => {
      const arr = listString?.split(',').map(s => s.trim()) || [];
      // show up to 25 list items. If list contains more than 25 items, use ellipses  
      return arr.slice(0, 25).join(', ') 
              + (arr.length > 25 ? ', ...' : '');
  }
  return (
      <PPSTemplate>
        <Table 
          inset={true}
          fullWidth={true}
        >
          <TableHeader>
            <tr>
              <th>Job Number</th>
              <th>Run ID</th>
              <th>Version</th>
              <th>Author</th>
              <th>Date Request</th>
              <th>Retail Code</th>
              <th>Hierarchy Type</th>
              <th>Hierarchy Codes</th>
              <th>Status</th>
              <th>Number of scores</th>
              <th>Exported to Salesforce</th>
            </tr>
          </TableHeader>
          <TableBody>
            {metaData.map(row => <tr>
              <td>{row.job_number}</td>
              <td>{row.run_id}</td>
              <td>{row.version}</td>
              <td>{row.author}</td>
              <td>{row.date_string}</td>
              <td>{row.retail_unit_code}</td>
              <td>{row.product_hierarchy_type}</td>
              <td>{listFormatter(row.product_hierarchy_numbers)}</td>
              <td>{row?.status}</td>
              <td>{row.score_count}</td>
              <td>{String(row.was_exported_to_salesforce)}</td>
            </tr>)}
          </TableBody>
        </Table>
      </PPSTemplate>
  )
}